
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { en, es } from '../locales';
import localeEnglish from 'date-fns/locale/en-US';
import localeSpanish from 'date-fns/locale/es';

const locale =
(navigator.languages && navigator.languages[0].substring(0, 2)) ||
navigator.language

// Configura i18next
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      es: {
        translation: es,
      },
    },
    lng: locale, // Idioma por defecto en caso de que no se pueda detectar
  
    interpolation: {
      escapeValue: false, // Permite renderizar etiquetas HTML en el texto traducido
    },
  });





export const localeCalendar = locale === 'en'? localeEnglish: localeSpanish
export default i18n;
